import { render, staticRenderFns } from "./ButtonVirtualVisit.vue?vue&type=template&id=658b6312&scoped=true&"
import script from "./ButtonVirtualVisit.vue?vue&type=script&lang=js&"
export * from "./ButtonVirtualVisit.vue?vue&type=script&lang=js&"
import style0 from "./ButtonVirtualVisit.vue?vue&type=style&index=0&id=658b6312&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "658b6312",
  null
  
)

export default component.exports